export default "__VITE_ASSET__Btjv4vce__"